// API configuration.
//
// All requests use a path that is RELATIVE to where the app is mounted
// (`PUBLIC_URL`, set from the `homepage` field in package.json — "/projects/exchange").
// That keeps a single code path working everywhere:
//   - production:    sanketr.com/projects/exchange/api/v1/...   -> Netlify redirect -> Netlify Function
//   - `netlify dev`: localhost:8888/projects/exchange/api/v1/... -> same redirects + local functions
const API_BASE_URL = `${process.env.PUBLIC_URL || ''}/api/v1`;

export const API_ENDPOINTS = {
  orderbook: (symbol) => `${API_BASE_URL}/orderbook/${symbol}`,
  trades: (symbol) => `${API_BASE_URL}/trades/${symbol}`,
  order: () => `${API_BASE_URL}/order`,
};

// Helper function for API calls
export const apiCall = async (url, options = {}) => {
  try {
    const response = await fetch(url, {
      headers: {
        'Content-Type': 'application/json',
        ...options.headers
      },
      ...options
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('API call failed:', error);
    throw error;
  }
};
